import _ from "lodash";
import * as type from "./types";
export default (state = {}, action) => {
  switch (action.type) {
    case type.FETCH_PETROL_EXPENSES:
      return { ..._.mapKeys(action.payload, "Id") };
    case type.FETCH_PETROL_EXPENSE:
      return { ...state, [action.payload.Id]: action.payload };
    case type.CREATE_PETROL_EXPENSE:
      return { ...state, [action.payload.Id]: action.payload };
    case type.EDIT_PETROL_EXPENSE:
      return { ...state, [action.payload.Id]: action.payload };
    case type.DELETE_PETROL_EXPENSE:
      return _.omit(state, action.payload);
    default:
      return state;
  }
};
